import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getDataConnect, connectDataConnectEmulator } from 'firebase/data-connect';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || '',
  authDomain: import.meta.env.VITE_AUTH_DOMAIN || '',
  projectId: import.meta.env.VITE_PROJECT_ID || '',
  storageBucket: import.meta.env.VITE_STORAGE_BUCKET || '',
  messagingSenderId: import.meta.env.VITE_MESSAGING_SENDER_ID || '',
  appId: import.meta.env.VITE_APP_ID || '',
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const functions = getFunctions(app, 'us-central1');

const isLocal =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname.includes('.localhost'));

const useRemoteDataConnect =
  String(import.meta.env.VITE_USE_REMOTE_DATACONNECT ?? '').trim() === 'true';

const disableAuthEmulator =
  import.meta.env.VITE_DISABLE_AUTH_EMULATOR === 'true' || useRemoteDataConnect;

if (isLocal) {
  if (!disableAuthEmulator) {
    const authEmulatorHost = import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_HOST || '127.0.0.1:9099';
    try {
      connectAuthEmulator(auth, `http://${authEmulatorHost}`, { disableWarnings: true });
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      if (!message.includes('already been called')) {
        console.warn('[app-oauth] Auth emulator connection failed:', error);
      }
    }
  }

  const functionsEmulator = import.meta.env.VITE_FUNCTIONS_EMULATOR_HOST || '127.0.0.1:5001';
  const [functionsHost, functionsPort] = functionsEmulator.split(':');
  try {
    connectFunctionsEmulator(functions, functionsHost, parseInt(functionsPort, 10));
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    if (!message.includes('already been called')) {
      console.warn('[app-oauth] Functions emulator connection failed:', error);
    }
  }
}

export function getOAuthDataConnect() {
  const connectorConfig = {
    connector: 'oauth-user',
    service: 'data-connect',
    location: 'us-central1',
  };
  const dc = getDataConnect(app, connectorConfig);

  if (isLocal && !useRemoteDataConnect) {
    const dcEmulatorHost = import.meta.env.VITE_DATACONNECT_EMULATOR_HOST || '127.0.0.1:9399';
    const [host, port] = dcEmulatorHost.split(':');
    try {
      connectDataConnectEmulator(dc, host, parseInt(port, 10));
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      if (!message.includes('already been called')) {
        console.warn('[app-oauth] Data Connect emulator connection failed:', error);
      }
    }
  }

  return dc;
}
